/* unplugin-vue-components disabled */import { render } from "./CustomersTable.vue?vue&type=template&id=4531425c&ts=true"
import script from "./CustomersTable.vue?vue&type=script&lang=ts"
export * from "./CustomersTable.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__